import type { MealCondition, MealMetric } from "@/lib/schema";

export const METRIC_LABELS: Record<MealMetric, string> = {
  kcal: "Kalorier",
  protein: "Protein",
  carbs: "Karbohydrater",
  fat: "Fett",
  fiber: "Fiber",
};

export const METRIC_LABELS_SHORT: Record<MealMetric, string> = {
  kcal: "kcal",
  protein: "Prot",
  carbs: "Karb",
  fat: "Fett",
  fiber: "Fiber",
};

export function metricUnit(metric: MealMetric): string {
  return metric === "kcal" ? "kcal" : "g";
}

export function conditionLabel(condition: MealCondition): string {
  const direction = condition.direction === "atMost" ? "Høyst" : "Minst";
  const amount = formatAmount(condition.threshold);
  if (condition.metric === "kcal") return `${direction} ${amount} kcal`;
  return `${direction} ${amount} g ${METRIC_LABELS[condition.metric].toLowerCase()}`;
}

export function formatAmount(value: number): string {
  if (!Number.isFinite(value)) return "—";
  return String(Math.round(value * 10) / 10);
}
